import { useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  TEXT_FEATURES,
  BODY_SPACING,
  SPACING,
} from "../../../../utils/constants/designConstants";
import { NAVIGATION_BUTTON_STYLES } from "../../../../utils/reusableStyles";

export const CostDriversSection = ({ costDrivers }) => {
  // CostDriver reduce Summary text
  const [expandedRows, setExpandedRows] = useState(null);

  const handleToggleExpand = (index) => {
    // If the clicked row is already expanded, collapse it, otherwise expand it
    setExpandedRows((prevIndex) => (prevIndex === index ? null : index));
  };

  if (!costDrivers || costDrivers.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
          mt: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_TOP,
          mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
        }}
      >
        Cost drivers aren't available at the moment.
      </Typography>
    );
  }

  try {
    return (
      <Box sx={{ mb: SPACING.SECTION_BOTTOM }}>
        {costDrivers.map((item, index) => {
          const isExpanded = expandedRows === index;
          const summaryText = item.Summary || "-";
          const indexText = item.Index || "-";
          const allocationText =
            item.Allocation != null ? `${item.Allocation.toFixed(2)}%` : "-";
          const shouldShowToggle =
            summaryText.length > TEXT_FEATURES.SUMMARY_EXPAND_THRESHOLD;

          return (
            <Box key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row", md: "row" },
                  alignItems: {
                    xs: "flex-start",
                    sm: "center",
                    md: "center",
                  },
                  gap: "3rem",
                  mb: SPACING.CONTENT_GAP,
                }}
              >
                {/* Allocation */}
                <Typography variant="subtitle1">{allocationText}</Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: SPACING.SMALL_GAP,
                  }}
                >
                  {/* Index */}
                  <Typography variant="subtitle3">{indexText}:</Typography>

                  {/* Summary */}
                  <Box
                    sx={{
                      display: "inline-block",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: isExpanded ? "none" : 5,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {summaryText}
                    </Typography>
                    {/* Show More/Less Text */}
                    {shouldShowToggle && (
                      <Box
                        sx={{
                          my: "1.5rem",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          onClick={() => handleToggleExpand(index)}
                          variant="text"
                          startIcon={
                            isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                          }
                          sx={{
                            ...NAVIGATION_BUTTON_STYLES,
                            color: "primary.brandSecondary",
                            textTransform: "capitalize",
                            "&: hover": {
                              backgroundColor: "primary.main",
                              color: "primary.white",
                            },
                          }}
                        >
                          {isExpanded ? "Show Less" : "Show More"}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  } catch (error) {
    console.error("Error rendering cost drivers table:", error);
    return (
      <Typography
        variant="body2"
        color="error"
        sx={{ py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING }}
      >
        Sorry, we couldn’t display cost drivers at the moment. Please try again
        later.
      </Typography>
    );
  }
};
